import makeDebugAPICall from "@src/utils/debuggerAxios";

const BASE_URL = "https://store-farhan.dev.classplus.co";

export const makeApiCal = (action) => {
  // PARAMETERS - method, route, storeData, catchError, body
  switch (action.method) {
    case "GET":
      return fetch(`${BASE_URL}/${action.route}`, {
        method: "GET",
        headers: {
          //   "x-access-token": token,
          "Content-Type": "application/json",
          Connection: "keep-alive",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          res?.status === "success"
            ? action.storeData(res?.data)
            : action.catchError(res.message);
        })
        .catch((err) => {
          action.catchError(err);
        });
    case "POST":
      return fetch(`${BASE_URL}/${action.route}`, {
        method: "POST",
        headers: {
          //   "x-access-token": token,
          "Content-Type": "application/json",
          Connection: "keep-alive",
        },
        body: JSON.stringify(action.body),
      })
        .then((res) => res.json())
        .then((res) => {
          res?.status === "success"
            ? action.storeData(res?.data)
            : action.catchError(res.message);
        })
        .catch((err) => action.catchError(err));
    default:
      return;
  }
};

export const directDeepLink = (url, source, logDeepLinksToLocal) => {
  // console.log(url, source, logDeepLinksToLocal);

  const action = {
    method: "POST",
    route: "v2/storeDeeplink",
    body: { deeplink: url },
    storeData: (e) => {
      // console.log(e)
    },
    catchError: (e) => {
      // console.error(e)
    },
  };
  switch (source) {
    case "SOURCE_HOME":
      return () => {
        window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
          JSON.stringify(url)
        );
        window?.mobile?.exceuteDeeplink(JSON.stringify(url));
        // makeApiCal(action);
        // if (logDeepLinksToLocal) {
        //   makeDebugAPICall(JSON.stringify(url));
        // }
      };
    case "SOURCE_WEBVIEW":
      return () => {
        // window?.webkit?.messageHandlers?.onDeeplinkExecuted?.postMessage(
        //   `${url?.screen},${url?.paramOne},${url?.paramTwo}`
        // );

        window?.webkit?.messageHandlers?.performAction?.postMessage(
          JSON.stringify(url)
        );
        window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(url));

        // makeApiCal(action);
        // if (logDeepLinksToLocal) {
        //   makeDebugAPICall(JSON.stringify(url));
        // }
      };
    case "CHAT_DETAILS_CREATE_V2":
      // alert("CHAT_DETAILS_CREATE_V2");
      return (url) => {
        // alertJSON.stringify(url));
        window?.webkit?.messageHandlers?.performAction?.postMessage(
          JSON.stringify(url)
        );

        // window?.mobile?.onDeeplinkExecuted(
        //   `${url?.screen},${url?.paramOne},${url?.paramTwo}${url?.paramThree}${url?.paramFour}`
        // );
        window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(url));

        // makeApiCal(action);
        // if (logDeepLinksToLocal) {
        //   makeDebugAPICall(JSON.stringify(url));
        // }
      };
    case "SCREEN_STORE_LISTING":
      return (data) => {
        window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(data));

        window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
          JSON.stringify(data)
        );
      };
    case "UTIL_WHATSAPP":
      //// alert);
      return (data) => {
        window.mobile.onDeeplinkExecutedV2(
          JSON.stringify({
            screen: "UTIL_WHATSAPP",
            paramOne: data?.paramOne,
            paramTwo: data?.paramTwo,
          })
        );
      };
    case "SOCIAL_LINKS_SHARE":
      return (data) => {
        window?.mobile?.onDeeplinkExecutedV2(
          JSON.stringify({
            screen: "SOCIAL_LINKS_SHARE",
            paramOne: data?.paramOne,
            paramTwo: data?.paramTwo,
            paramThree: data?.paramThree,
          })
        );
      };
    case "UTIL_DOWNLOAD":
      return (jsonVal) => {
        window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(jsonVal));
        //ios
        window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
          JSON.stringify(jsonVal)
        );
      };
    case "UTIL_WEBVIEW":
      return (data) => {
        window?.mobile?.onDeeplinkExecutedV2(
          JSON.stringify({
            screen: "UTIL_WEBVIEW",
            paramOne: data?.paramOne,
            paramThree: data?.paramThree,
          })
        );
      };
    case "ACTION_SHARE_COURSE":
      return (data) => {
        window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
          JSON.stringify({
            screen: "ACTION_SHARE_COURSE",
            paramOne: JSON.stringify(data?.socialLinks),
          })
        );
      };
    case "UTIL_BROWSER":
      return (data) => {
        // console.log(data?.shareUrl);

        // console.log(data?.shareUrl);
        // console.log(
        //   JSON.stringify({
        //     screen: "UTIL_BROWSER",
        //     paramOne: data?.shareUrl,
        //   })
        // );
        window?.mobile?.onDeeplinkExecutedV2(
          JSON.stringify({
            screen: "UTIL_BROWSER",
            paramOne: data?.shareUrl,
          })
        );
        window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
          JSON.stringify({
            screen: "UTIL_BROWSER",
            paramOne: data?.shareUrl,
          })
        );
      };

    case "UTIL_SHARE":
      return (data) => {
        window?.mobile?.onDeeplinkExecutedV2(
          JSON.stringify({ screen: "UTIL_SHARE", paramOne: data?.paramTwo })
        );
        window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
          JSON.stringify({ screen: "UTIL_SHARE", paramOne: data?.paramTwo })
        );
      };

    case "UTIL_COPY":
      return () => {
        window?.webkit?.messageHandlers?.onDeeplinkExecutedV2?.postMessage(
          JSON.stringify(url)
        );
        window?.mobile?.onDeeplinkExecutedV2(
          JSON.stringify({
            screen: "UTIL_COPY",
            paramOne: url,
          })
        );
        // makeApiCal(action);
        // if (logDeepLinksToLocal) {
        //   makeDebugAPICall(JSON.stringify(url));
        // }
      };
    default:
      return;
  }
};
